export interface NavigationItem {
  readonly label: string
  readonly path: string
}

export interface NavigationSection {
  readonly key: string
  readonly label: string
  readonly items: readonly NavigationItem[]
}

export const configurationNavigationSections: readonly NavigationSection[] = [
  {
    key: 'start',
    label: 'Start',
    items: [
      { label: 'Dashboard', path: '/dashboard' },
    ],
  },
  {
    key: 'foundation-engine',
    label: 'Foundation / Engine',
    items: [
      { label: 'SIP Engines', path: '/system/containers' },
      { label: 'SIP Identities', path: '/foundation/hosts' },
    ],
  },
  {
    key: 'local-sip-media',
    label: 'Local SIP and Media',
    items: [
      { label: 'Certificates', path: '/foundation/certificates' },
      { label: 'Media Realms', path: '/foundation/media-realms' },
      { label: 'SIP Interfaces', path: '/foundation/sip-interfaces' },
      { label: 'TLS Contexts', path: '/foundation/tls-contexts' },
    ],
  },
  {
    key: 'profiles',
    label: 'Profiles',
    items: [
      { label: 'SIP Profiles', path: '/connectivity/sip-profiles' },
      { label: 'Codec Groups', path: '/foundation/codec-groups' },
    ],
  },
  {
    key: 'peers',
    label: 'Peers',
    items: [
      { label: 'SIP Peers', path: '/connectivity/sip-peers' },
      { label: 'Peer Groups', path: '/connectivity/peer-groups' },
      { label: 'SIP Registrations', path: '/connectivity/sip-registrations' },
    ],
  },
  {
    key: 'authentication',
    label: 'Authentication and registration',
    items: [
      { label: 'SIP Authentication', path: '/security/sip-authentication' },
    ],
  },
  {
    key: 'manipulation',
    label: 'Manipulation',
    items: [
      { label: 'SIP Manipulations', path: '/connectivity/sip-manipulations' },
    ],
  },
  {
    key: 'routing',
    label: 'Classification and routing',
    items: [
      { label: 'Business Call Handling', path: '/intelligence/business-call-handling' },
      { label: 'Routing Rules', path: '/intelligence/routing-rules' },
    ],
  },
  {
    key: 'observability',
    label: 'Observability / System',
    items: [
      { label: 'Active Calls', path: '/system/ongoing-calls' },
      { label: 'Logs', path: '/system/logs' },
      { label: 'SIP Traffic', path: '/system/sip-traffic-logs' },
      { label: 'Call History', path: '/system/call-history' },
      { label: 'Push Gateway', path: '/system/push-gateway' },
    ],
  },
  {
    key: 'utilities',
    label: 'Utilities',
    items: [
      { label: 'Backup & Restore', path: '/backup-restore' },
      { label: 'System Settings', path: '/settings/system' },
    ],
  },
] 

export function flattenNavigationItems(): readonly NavigationItem[] {
  return configurationNavigationSections.flatMap((section) => section.items)
}
